export { minus, plus, input_basket, delete_item } from '../../module/shop_scripts/basket_action';
export { nova_pochta } from '../../module/shop_scripts/order_action';
export { change_counter } from '../../module/shop_scripts/change_counter';
